import React, { useMemo } from 'react';
import { EditorPopup, PopupEditorOptions } from './EditorPopup';
import { IEditorProps } from './Editor';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { ObjectSelectionOptions } from '@decisions/server/DecisionsFramework/Design/Properties';
import { getPopupEditorValueString } from 'components/property-editors/editors/EditorStringValueUtils';
// import './GridPopupEditor.less'

interface IGridPopupEditorProps extends IEditorProps {
  children?: React.ReactNode;
}

export interface GridPopupEditorOptions extends PopupEditorOptions {
  selectionOption: ObjectSelectionOptions;
  typeName: string;
}

/**
 * Default Grid Popup Editor.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function GridPopupEditor(props: IGridPopupEditorProps) {
  const { child, children } = props;
  const options: GridPopupEditorOptions = useMemo(() => {
    return {
      typeName: getEditorConfigValue(child, 'TypeName'),
      selectionOption: getEditorConfigValue(child, 'ObjectSelectionOptions'),
      showLoadFromDataButton: getEditorConfigValue(child, 'showLoadFromDataButton'),
    };
  }, [child]);

  const valueString = children ? null : getPopupEditorValueString(child);

  return (
    <EditorPopup {...props} dialogOptions={options}>
      {children ?? (valueString ? <label title={valueString}>{valueString}</label> : undefined)}
    </EditorPopup>
  );
}
